import compact from 'lodash/compact';

/**
 * Services that users choose for signup.
 */
export enum SignupService {
  Insurance = 'insurance',
  Refi = 'refi',
  Garage = 'garage',
  Dwep = 'dwep',
  Ebay = 'eBay',
}

export enum UpdatePolicyInfoSteps {
  Drivers = 'Drivers',
  NNODriverLicense = 'NNODriverLicense',
}

/**
 * Vin source enum
 */
export enum VinSourceEnum {
  UserInput = 'User Input',
  UserYMMK = 'User YMMK', // EZlynx or ITC
  LN = 'LN',
  Database = 'Database',
  Partner = 'Partner', // actually all partner vins are replaced by EZlynx or ITC
  CRMYMMK = 'CRM YMMK',
  CRMInput = 'CRM Input',
  CarrierAL3 = 'Carrier AL3', // Carrier AL3 file
}

/**
 * Get the product text variable for onboarding_resume_variable and signup_resume_variable journey based on the services user selected.
 */
export const getResumeJourneyProductText = (args: {
  hasInsuranceService: boolean;
  hasGarageService: boolean;
  hasDWEPService: boolean;
  hasRefiService: boolean;
}): string => {
  const { hasInsuranceService, hasGarageService, hasDWEPService, hasRefiService } = args;
  const numServices = compact([hasInsuranceService, hasGarageService, hasDWEPService, hasRefiService]).length;

  if (numServices === 2) {
    if (hasInsuranceService && hasGarageService) {
      return 'help you start comparing insurance rates and provide automatic car maintenance reminders.';
    }
    if (hasInsuranceService && hasDWEPService) {
      return 'help you start comparing insurance rates and earn safe driving rewards.';
    }
    if (hasInsuranceService && hasRefiService) {
      return 'help you start your auto loan refinance application and compare insurance rates.';
    }
    if (hasGarageService && hasDWEPService) {
      return 'start providing automatic car maintenance reminders and help you earn safe driving rewards.';
    }
    if (hasGarageService && hasRefiService) {
      return 'help you start your auto loan refinance application and provide automatic car maintenance reminders.';
    }
    if (hasDWEPService && hasRefiService) {
      return 'help you start your auto loan refinance application and earn safe driving rewards.';
    }
  }

  if (numServices === 1) {
    if (hasInsuranceService) {
      return 'start comparing insurance rates.';
    }
    if (hasGarageService) {
      return 'start sending you automatic car maintenance reminders.';
    }
    if (hasDWEPService) {
      return 'start earning rewards for safe driving.';
    }
    if (hasRefiService) {
      return 'help you start your auto loan refinance application.';
    }
  }

  return 'help you get started  🎉';
};
